import React from "react";

export const SPIRITUAL_DISCLAIMER_TEXT =
  "Lyon's Den Protection services are provided for spiritual guidance, reflection, personal empowerment, and educational purposes. No specific outcome is guaranteed.";

export default function SpiritualDisclaimer({ className = "" }) {
  return (
    <div
      className={`mt-12 border border-[#D4AF37]/25 bg-[#0A0A0A] px-6 py-5 ${className}`}
      data-testid="spiritual-disclaimer"
    >
      <div className="overline text-[#D4AF37] mb-2">Spiritual Disclaimer</div>
      <p className="text-sm text-white/65 leading-relaxed">{SPIRITUAL_DISCLAIMER_TEXT}</p>
    </div>
  );
}
